var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPcc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.24,
    height: 45.316,
    viewBox: "0 0 143.24 45.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338",
    transform: "translate(-3.8 -3.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_317",
    "data-name": "Grupo 317",
    transform: "translate(51.145 13.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M82.056,17.1,76.87,32.431H71.985L66.8,17.1v-.225h4.133l3.532,11.648h.075L77.922,16.8h4.133Z",
    transform: "translate(-66.8 -16.8)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_318",
    "data-name": "Grupo 318",
    transform: "translate(66.626 13.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_156",
    "data-name": "Trazado 156",
    d: "M101,16.875l2.555,10.972h.075l2.33-10.972h4.058V17.1l-4.058,15.331H101.3l-2.555-10.9h-.075L96.118,32.356H91.458L87.4,17.025V16.8h4.058l2.4,11.047h0l2.555-10.972Z",
    transform: "translate(-87.4 -16.8)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_319",
    "data-name": "Grupo 319",
    transform: "translate(91.05 13.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    "data-name": "Trazado 157",
    d: "M127.866,24.641,131.7,16.9h4.058V32.456h-3.833V23.138h-.075l-2.33,5.336h-3.532l-2.33-5.336h.075v9.244H119.9V16.9h4.058l3.908,7.741Z",
    transform: "translate(-119.9 -16.9)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_320",
    "data-name": "Grupo 320",
    transform: "translate(109.763 21.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    "data-name": "Trazado 158",
    d: "M144.8,30.256V27.4h6.839v2.856Z",
    transform: "translate(-144.8 -27.4)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_321",
    "data-name": "Grupo 321",
    transform: "translate(119.382 13.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    d: "M161.433,32.381H157.6V16.9h3.833Z",
    transform: "translate(-157.6 -16.9)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_322",
    "data-name": "Grupo 322",
    transform: "translate(125.169 13.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_160",
    "data-name": "Trazado 160",
    d: "M177.474,16.875v3.081h-4.208v12.4h-3.833v-12.4H165.3V16.8h12.174Z",
    transform: "translate(-165.3 -16.8)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    "data-name": "Grupo 323",
    transform: "translate(51.145 32.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M69.581,42.1a4.039,4.039,0,0,1,1.578.376l-.225.676a3.166,3.166,0,0,0-1.353-.3c-1.353,0-1.954.977-1.954,2.48s.6,2.48,1.954,2.48a2.948,2.948,0,0,0,1.353-.3l.225.676a4.039,4.039,0,0,1-1.578.376c-1.8,0-2.781-1.278-2.781-3.231C66.875,43.378,67.777,42.1,69.581,42.1Z",
    transform: "translate(-66.8 -42.1)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324",
    transform: "translate(56.18 34.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_162",
    "data-name": "Trazado 162",
    d: "M75.6,49.159c-1.5,0-2.1-1.052-2.1-2.33s.6-2.33,2.1-2.33,2.1,1.052,2.1,2.33S77.107,49.159,75.6,49.159Zm0-.676c.977,0,1.278-.676,1.278-1.653s-.376-1.653-1.278-1.653-1.278.676-1.278,1.653S74.7,48.483,75.6,48.483Z",
    transform: "translate(-73.5 -44.5)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    transform: "translate(61.366 34.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_163",
    "data-name": "Trazado 163",
    d: "M81.076,44.65l.075.376h0a2.53,2.53,0,0,1,1.5-.526,1.5,1.5,0,0,1,1.278.6h0a2.575,2.575,0,0,1,1.578-.6,1.449,1.449,0,0,1,1.578,1.653v2.856h-.827V46.3c0-.752-.225-1.127-.977-1.127a2.2,2.2,0,0,0-1.2.526c0,.15.075.3.075.451v2.856h-.827V46.3c0-.752-.15-1.127-.9-1.127a1.938,1.938,0,0,0-1.2.451v3.382H80.4V44.575h.676Z",
    transform: "translate(-80.4 -44.5)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326",
    transform: "translate(69.332 34.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_164",
    "data-name": "Trazado 164",
    d: "M91.526,44.65l.075.376h0a2.53,2.53,0,0,1,1.5-.526,1.5,1.5,0,0,1,1.278.6h0a2.575,2.575,0,0,1,1.578-.6,1.449,1.449,0,0,1,1.578,1.653v2.856h-.827V46.3c0-.752-.225-1.127-.977-1.127a2.2,2.2,0,0,0-1.2.526c0,.15.075.3.075.451v2.856h-.827V46.3c0-.752-.15-1.127-.9-1.127a1.938,1.938,0,0,0-1.2.451v3.382H91V44.575h.526Z",
    transform: "translate(-91 -44.5)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327",
    transform: "translate(76.847 34.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_165",
    "data-name": "Trazado 165",
    d: "M101.827,47.03a1.263,1.263,0,0,0,1.353,1.353,1.99,1.99,0,0,0,1.278-.376l.3.6a3.1,3.1,0,0,1-1.653.451,2.074,2.074,0,0,1-2.1-2.33,2.1,2.1,0,0,1,2.029-2.33,1.732,1.732,0,0,1,1.879,1.879,1.866,1.866,0,0,1-.075.676h-3.006Zm2.33-.6V46.2a1.008,1.008,0,0,0-1.127-1.052,1.253,1.253,0,0,0-1.2,1.278Z",
    transform: "translate(-101 -44.4)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328",
    transform: "translate(81.732 34.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_166",
    "data-name": "Trazado 166",
    d: "M108.176,44.65l.075.451h0a1.46,1.46,0,0,1,1.2-.6c.15,0,.376,0,.451.075l-.15.752c-.15,0-.3-.075-.451-.075a1.07,1.07,0,0,0-.977.676v3.156H107.5V44.65Z",
    transform: "translate(-107.5 -44.5)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(84.587 34.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_167",
    "data-name": "Trazado 167",
    d: "M113.4,44.5a3.955,3.955,0,0,1,1.353.3l-.225.676a3.691,3.691,0,0,0-1.127-.225c-.9,0-1.278.827-1.278,1.653s.376,1.653,1.278,1.653a4.991,4.991,0,0,0,1.127-.225l.225.676a3.955,3.955,0,0,1-1.353.3,2.077,2.077,0,0,1-2.1-2.33C111.375,45.477,112.127,44.5,113.4,44.5Z",
    transform: "translate(-111.3 -44.5)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    transform: "translate(88.946 32.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_168",
    "data-name": "Trazado 168",
    d: "M117.626,42.1a.526.526,0,1,1-.526.526A.514.514,0,0,1,117.626,42.1Zm-.376,6.313V43.979h.827v4.434Z",
    transform: "translate(-117.1 -42.1)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331",
    transform: "translate(90.9 34.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_169",
    "data-name": "Trazado 169",
    d: "M122.481,48.633a2.373,2.373,0,0,1-1.428.526,1.261,1.261,0,0,1-1.353-1.353c0-1.052.827-1.428,2.029-1.428h.676v-.225a.873.873,0,0,0-.977-.977,2.271,2.271,0,0,0-1.2.376l-.3-.6a2.385,2.385,0,0,1,1.5-.451,1.548,1.548,0,0,1,1.728,1.728v2.029c0,.15,0,.225.225.225h.225v.676c-.15,0-.3.075-.451.075a.917.917,0,0,1-.676-.6Zm-.676-1.578c-.977,0-1.353.3-1.353.752s.3.676.752.676a2.025,2.025,0,0,0,1.127-.376V47.055Z",
    transform: "translate(-119.7 -44.5)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    transform: "translate(95.785 32.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_170",
    "data-name": "Trazado 170",
    d: "M127.628,48.463c-.15,0-.3.075-.526.075-.6,0-.9-.376-.9-1.052V42h.827v5.561c0,.15,0,.225.225.225h.376Z",
    transform: "translate(-126.2 -42)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    transform: "translate(11.165 8.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171",
    "data-name": "Trazado 171",
    d: "M27.5,44.343l-.451-2.63a14.772,14.772,0,0,1-3.006-1.2l-2.179,1.578a1.149,1.149,0,0,1-1.5-.15l-3.307-3.307a1.245,1.245,0,0,1-.15-1.5l1.578-2.179a11.437,11.437,0,0,1-1.2-3.006l-2.705-.451a1.2,1.2,0,0,1-.977-1.127V25.705a1.078,1.078,0,0,1,.977-1.127l2.705-.451a14.772,14.772,0,0,1,1.2-3.006l-1.578-2.255a1.149,1.149,0,0,1,.15-1.5l3.307-3.307a1.245,1.245,0,0,1,1.5-.15l2.179,1.578a14.772,14.772,0,0,1,3.006-1.2l.451-2.705A1.2,1.2,0,0,1,28.63,10.6h4.735a1.078,1.078,0,0,1,1.127.977l.451,2.705a14.772,14.772,0,0,1,3.006,1.2l2.179-1.578a1.149,1.149,0,0,1,1.5.15l3.307,3.307a1.245,1.245,0,0,1,.15,1.5L43.51,21.046a14.772,14.772,0,0,1,1.2,3.006l2.705.451a1.2,1.2,0,0,1,.977,1.127v4.735a1.078,1.078,0,0,1-.977,1.127l-2.781.451a14.772,14.772,0,0,1-1.2,3.006l1.578,2.179a1.149,1.149,0,0,1-.15,1.5l-3.307,3.307a1.245,1.245,0,0,1-1.5.15L37.874,40.51a14.773,14.773,0,0,1-3.006,1.2l-.451,2.705a1.2,1.2,0,0,1-1.127.977H28.555A1.2,1.2,0,0,1,27.5,44.343Zm5.261-3.758a1.317,1.317,0,0,1,.9-.977,13.106,13.106,0,0,0,3.682-1.5,1.138,1.138,0,0,1,1.278.075l2.029,1.428,1.954-1.954L41.18,35.625a1.138,1.138,0,0,1-.075-1.278,11.207,11.207,0,0,0,1.5-3.682,1.12,1.12,0,0,1,.977-.9l2.48-.376V26.607l-2.48-.376a1.317,1.317,0,0,1-.977-.9,13.106,13.106,0,0,0-1.5-3.682,1.138,1.138,0,0,1,.075-1.278l1.428-2.029-1.954-1.954-2.029,1.428a1.138,1.138,0,0,1-1.278.075,11.207,11.207,0,0,0-3.682-1.5,1.12,1.12,0,0,1-.9-.977l-.376-2.48H29.607l-.451,2.48a1.317,1.317,0,0,1-.9.977,13.106,13.106,0,0,0-3.682,1.5,1.138,1.138,0,0,1-1.278-.075l-2.029-1.428-1.954,1.954,1.428,2.029a1.138,1.138,0,0,1,.075,1.278,11.207,11.207,0,0,0-1.5,3.682,1.12,1.12,0,0,1-.977.9l-2.48.376v2.705l2.48.451a1.12,1.12,0,0,1,.9.9,13.106,13.106,0,0,0,1.5,3.682,1.138,1.138,0,0,1-.075,1.278l-1.428,2.029,1.954,1.954,2.029-1.428a1.138,1.138,0,0,1,1.278-.075,11.207,11.207,0,0,0,3.682,1.5,1.12,1.12,0,0,1,.9.977l.376,2.48h2.781Z",
    transform: "translate(-13.6 -10.6)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    transform: "translate(21.611 26.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_172",
    "data-name": "Trazado 172",
    d: "M27.5,40.689h2.33v-2.33c0-1.353,2.4-2.33,4.659-2.33s4.659.977,4.659,2.33v2.33h2.33v-2.33c0-3.006-3.607-4.659-6.914-4.659s-6.914,1.653-6.914,4.659v2.33Z",
    transform: "translate(-27.5 -33.7)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    transform: "translate(23.94 18.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_173",
    "data-name": "Trazado 173",
    d: "M30.6,28.787V27.659a4.659,4.659,0,1,1,9.319,0v1.127a4.659,4.659,0,1,1-9.319,0Zm2.255-1.2v1.127a2.33,2.33,0,1,0,4.659,0V27.584a2.33,2.33,0,1,0-4.659,0Z",
    transform: "translate(-30.6 -23)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336",
    transform: "translate(3.8 3.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_174",
    "data-name": "Trazado 174",
    d: "M142.829,48.916H8.008A4.218,4.218,0,0,1,3.8,44.632V7.884A4.266,4.266,0,0,1,8.008,3.6H142.829a4.218,4.218,0,0,1,4.208,4.284V44.632A4.218,4.218,0,0,1,142.829,48.916ZM8.008,5.554a2.278,2.278,0,0,0-2.255,2.33V44.632a2.327,2.327,0,0,0,2.255,2.33H142.829a2.278,2.278,0,0,0,2.255-2.33V7.884a2.327,2.327,0,0,0-2.255-2.33Z",
    transform: "translate(-3.8 -3.6)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337",
    transform: "translate(100.068 32.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_175",
    "data-name": "Trazado 175",
    d: "M134.73,42.07a3.906,3.906,0,0,1,1.632.4l-.225.658a3.3,3.3,0,0,0-1.406-.289c-1.379,0-1.973.947-1.973,2.433s.594,2.433,1.973,2.433a3.309,3.309,0,0,0,1.406-.288l.225.658a3.9,3.9,0,0,1-1.632.4c-1.838,0-2.83-1.289-2.83-3.2S132.892,42.07,134.73,42.07Z",
    transform: "translate(-131.9 -42.07)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_176",
    "data-name": "Trazado 176",
    d: "M139.683,44.624v2.659c0,.749.262,1.109.938,1.109a2.361,2.361,0,0,0,1.19-.424V44.624h.811v4.344h-.576l-.1-.4h-.019a2.848,2.848,0,0,1-1.5.531,1.452,1.452,0,0,1-1.55-1.659V44.624Z",
    transform: "translate(-133.632 -42.705)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_177",
    "data-name": "Trazado 177",
    d: "M145.377,48a2.4,2.4,0,0,0,1.28.37c.6,0,.892-.216.892-.613,0-.315-.189-.468-.649-.6L146.377,47c-.748-.216-1.208-.541-1.208-1.235,0-.794.6-1.326,1.613-1.326a3.547,3.547,0,0,1,1.486.307l-.252.658a2.856,2.856,0,0,0-1.19-.271c-.585,0-.847.216-.847.6,0,.289.144.432.64.567l.514.135c.748.189,1.225.577,1.225,1.289,0,.8-.612,1.325-1.631,1.325a3.012,3.012,0,0,1-1.641-.415Z",
    transform: "translate(-135.177 -42.66)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_178",
    "data-name": "Trazado 178",
    d: "M151.679,43.281V44.29h1.163v.667h-1.163v2.587c0,.361.18.514.478.514a2.926,2.926,0,0,0,.676-.108v.694a3.344,3.344,0,0,1-.856.126.981.981,0,0,1-1.108-1.072v-2.74h-.775v-.487l.775-.18V43.281Z",
    transform: "translate(-136.421 -42.371)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_179",
    "data-name": "Trazado 179",
    d: "M156.659,49.059a2.032,2.032,0,0,1-2.127-2.307,2.151,2.151,0,1,1,4.29,0A2.049,2.049,0,0,1,156.659,49.059Zm0-.712c.974,0,1.335-.694,1.335-1.6s-.361-1.6-1.335-1.6-1.3.694-1.3,1.6S155.695,48.347,156.659,48.347Z",
    transform: "translate(-137.524 -42.66)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_180",
    "data-name": "Trazado 180",
    d: "M162.089,44.579l.1.4h.018a2.844,2.844,0,0,1,1.541-.532,1.371,1.371,0,0,1,1.28.586h.027a2.715,2.715,0,0,1,1.586-.586,1.455,1.455,0,0,1,1.6,1.659v2.821h-.812V46.265c0-.748-.225-1.108-.982-1.108a2.031,2.031,0,0,0-1.2.513,2.148,2.148,0,0,1,.046.433v2.821h-.812V46.265c0-.748-.18-1.108-.928-1.108a2.336,2.336,0,0,0-1.208.424v3.343h-.812V44.579Z",
    transform: "translate(-139.265 -42.66)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_181",
    "data-name": "Trazado 181",
    d: "M172.524,47.013a1.3,1.3,0,0,0,1.379,1.353,2.2,2.2,0,0,0,1.3-.388l.316.613a3.005,3.005,0,0,1-1.686.468,2.068,2.068,0,0,1-2.127-2.325,2.078,2.078,0,0,1,2.046-2.29,1.77,1.77,0,0,1,1.937,1.875,4.923,4.923,0,0,1-.054.694Zm2.37-.649a1.231,1.231,0,0,0,.01-.189,1.019,1.019,0,0,0-1.154-1.036,1.194,1.194,0,0,0-1.226,1.226Z",
    transform: "translate(-141.791 -42.66)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_182",
    "data-name": "Trazado 182",
    d: "M178.844,44.579l.1.469h.018a1.531,1.531,0,0,1,1.208-.6,1.729,1.729,0,0,1,.468.063l-.116.73a2.462,2.462,0,0,0-.442-.045,1.014,1.014,0,0,0-1,.631v3.1h-.812V44.579Z",
    transform: "translate(-143.422 -42.66)",
    fill: "#999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPcc);
export default __webpack_public_path__ + "static/media/logo_pcc.50bd4370443c4c700434923c9208704d.svg";
export { ForwardRef as ReactComponent };